export const shouldLoad = () => document.querySelector('.klt-password-field') !== undefined;